import { ArrowUpRight } from "@phosphor-icons/react";

import "./contact.scss";

export default function Contact() {
  return (
    <section className="contact" id="contact">
      <div className="contact-grid">
        <div className="contact-copy">
          <h2 className="section-heading">Let's talk.</h2>
          <p className="section-lede">
            Games, backend systems, or a role you think I'd fit: send a message
            and I'll get back to you.
          </p>
        </div>
        <form action="https://formspree.io/f/xvolnwob" method="POST" className="contact-form">
          <div className="field">
            <label htmlFor="contact-email">Email</label>
            <input id="contact-email" type="email" name="email" required autoComplete="email" inputMode="email" />
            <span className="field-error">Enter a valid email address.</span>
          </div>
          <div className="field">
            <label htmlFor="contact-message">Message</label>
            <textarea id="contact-message" name="message" rows="6" required minLength="10"></textarea>
            <span className="field-error">Write at least a sentence.</span>
          </div>
          <button className="btn primary" type="submit">
            Send message
            <span className="btn-icon"><ArrowUpRight size={16} weight="bold" /></span>
          </button>
        </form>
      </div>
    </section>
  );
}
